// extracted by mini-css-extract-plugin
export default {"loginPage":"login_loginPage__hHguM","formSide":"login_formSide__Esmoj","container":"login_container__A3Zne"};